// src/theme.js
const shared = {
  radius: { xs: 6, sm: 10, md: 14, lg: 18, xl: 24, pill: 999 },
  shadow: {
    sm: '0 2px 8px rgba(0,0,0,.06)',
    md: '0 8px 24px rgba(0,0,0,.08)',
    lg: '0 12px 36px rgba(0,0,0,.12)'
  },
  spacing: (n) => `${n * 4}px`,
  container: 'min(1160px, calc(100% - 40px))',
  font: {
    family: `Inter, SF Pro Text, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif`,
    sizes: {
      h1: 'clamp(40px, 6vw, 64px)',
      h2: 'clamp(28px, 4vw, 40px)',
      h3: 'clamp(20px, 2.6vw, 24px)',
      body: '18px',
      small: '14px'
    }
  }
};

export const lightTheme = {
  ...shared,
  mode: 'light',
  bg: '#f4f6f9',
  body: '#eceff4',
  surface: '#f7f8fb',
  text: '#0f1012',
  textMuted: 'rgba(15,16,18,.72)',
  border: 'rgba(0,0,0,.08)',
  accent: '#ff6600',
  accentDark: '#e55500',
  // добавлено, чтобы не падать на hover в Header:
  muted: 'rgba(0,0,0,.06)'
};

export const darkTheme = {
  ...shared,
  mode: 'dark',
  bg: '#0f1012',
  body: '#16181b',
  surface: '#121417',
  text: '#f0f2f4',
  textMuted: 'rgba(240,242,244,.72)',
  border: 'rgba(255,255,255,.12)',
  accent: '#ff6600',
  accentDark: '#e55500',
  // добавлено
  muted: 'rgba(255,255,255,.06)'
};
